export enum IdentificationTypeEnum {
  PASSPORT = "passport_number",
  ID = "id_card_number",
}

export function formatIdentification(
  type?: IdentificationTypeEnum,
  number?: string,
): string {
  const idTypeMap: Record<IdentificationTypeEnum, string> = {
    [IdentificationTypeEnum.PASSPORT]: "Passport -",
    [IdentificationTypeEnum.ID]: "ID -",
  };

  return type && number ? `${idTypeMap[type] || "Unknown -"} ${number}` : "N/A";
}
